
import { Component, Vue, Watch } from 'vue-property-decorator';
import { changeLoading } from '@/util/decorators';
// import {
//   editAccountPrivilege,
//   getAccountPrivilege,
//   getPrivilegeList,
//   initUserInfo,
//   initPrivilegeList,
//   // UserInfo,
//   // PrivilegeData,
// } from '@/api/setting/edit-account';
const { VUE_APP_LIMIT: LimitApi } = process.env;
const API = {
  user_info: `${LimitApi}/boss/setting/auth/user/rule`,
  privilege_info: `${LimitApi}/boss/setting/auth/rule`,
  submit_data: `${LimitApi}/boss/setting/auth/user/rule`,
};
@Component
export default class ListTemplate extends Vue {
  is_loading = false;
  // privilege_list = initPrivilegeList();
  privilege_list: any = [];
  user_id = 0;
  user_info: any = {
    privilege: []
  };


  // 提交
  // @changeLoading(['is_loading'])
  async submit() {
    const {data} = await this.$axios.put(`${API.submit_data}/${this.$route.query.id}`, {
      rule: this.user_info.privilege,
    })
    if(data.status === 200) {
      this.$message.success('保存成功');
      this.$router.back()
    } else {
      this.$message.error(data.message);
    }
    // const res: any = await editAccountPrivilege(this.user_id, this.user_info.privilege.join(','));
    // if (res.status !== 200) {
    //   this.$message.error(res.message);
    //   return;
    // }
    // this.$message.success('编辑成功');
  }

  @Watch('user_info', { deep: true })
  changePrivilege() {
    
    for (let i = 0; i < this.privilege_list.length; i++) {
      let count = 0;
      let parent_indeterminate_count = 0;
      for (let j = 0; j < this.privilege_list[i].parent.length; j++) {
        let count2 = 0;
        let indeterminate_count = 0;
        if (this.user_info.privilege.indexOf(this.privilege_list[i].parent[j].id) === -1) {
          count++;
        } else {
          parent_indeterminate_count++;
        }
        if (this.privilege_list[i].parent[j].parent) {
          for (let k = 0; k < this.privilege_list[i].parent[j].parent.length; k++) {
            if (
              this.user_info.privilege.indexOf(this.privilege_list[i].parent[j].parent[k].id) === -1
            ) {
              count2++;
            } else {
              indeterminate_count++;
            }
          }
          if (
            count2 === this.privilege_list[i].parent[j].parent.length &&
            this.user_info.privilege.indexOf(this.privilege_list[i].parent[j].id) !== -1
          ) {
            this.user_info.privilege.splice(
              this.user_info.privilege.indexOf(this.privilege_list[i].parent[j].id),
              1
            );
          }
        }
        if (
          indeterminate_count !== 0 &&
          indeterminate_count !== this.privilege_list[i].parent[j].parent.length
        ) {
          this.privilege_list[i].parent[j].indeterminate = true;
        } else {
          this.privilege_list[i].parent[j].indeterminate = false;
        }
      }
      if (
        count === this.privilege_list[i].parent.length &&
        this.user_info.privilege.indexOf(this.privilege_list[i].id) !== -1
      ) {
        this.user_info.privilege.splice(
          this.user_info.privilege.indexOf(this.privilege_list[i].id),
          1
        );
      }
        // console.log(parent_indeterminate_count);
        // console.log(this.privilege_list[i].parent);
      if (
        parent_indeterminate_count !== 0 &&
        parent_indeterminate_count !== this.privilege_list[i].parent.length
      ) {
        this.privilege_list[i].parent_indeterminate = true;
      } else {
        this.privilege_list[i].parent_indeterminate = false;
      }
        // console.log(this.privilege_list[i].parent_indeterminate);
    }
  }

  changeCheckBox(e: any, item: any, level: number) {
    // console.log(this.privilege_list)
    if (e.target.checked) {
      this.user_info.privilege.push(item.id);
      if (level === 1) {
        item.parent.forEach((item2: any) => {
          this.user_info.privilege.push(item2.id);
          item2.parent.forEach((item3: any) => {
            this.user_info.privilege.push(item3.id);
          });
        });
      }
      if (level === 2) {
        this.user_info.privilege.push(item.parent_id);
        item.parent.forEach((item2: any) => {
          this.user_info.privilege.push(item2.id);
        });
      }
      if (level === 3) {
        this.user_info.privilege.push(item.parent_id);
        this.privilege_list.forEach((item2: any) => {
          item2.parent.forEach((item3: any) => {
            if (item3.id === item.parent_id) {
              this.user_info.privilege.push(item2.id);
            }
          });
        });
      }
      this.user_info.privilege = [...new Set(this.user_info.privilege)];
    } else {
      if (level === 1) {
        const arr: any[] = [];
        item.parent.forEach((item: any) => {
          arr.push(item.id);
          item.parent.forEach((item: any) => {
            arr.push(item.id);
          });
        });
        this.deleteId(item, arr);
      }
      if (level === 2) {
        const arr = item.parent.map((item: any) => {
          return item.id;
        });
        this.deleteId(item, arr);
      }
      if (level === 3) {
        this.deleteId(item);
      }
    }
  }

  deleteId(item: any, arr: any = []) {
    this.user_info.privilege.splice(this.user_info.privilege.indexOf(item.id), 1);
    arr.forEach((item: any) => {
      if (this.user_info.privilege.indexOf(item) !== -1) {
        this.user_info.privilege.splice(this.user_info.privilege.indexOf(item), 1);
      }
    });
  }

  // 获取所有权限列表
  @changeLoading(['is_loading'])
  async getPrivilegeList() {
    const {data} = await this.$axios.get(`${API.privilege_info}?product_id=${this.$route.query.product_id}`)
    if(data.status === 200) {
      const res_data = JSON.parse(JSON.stringify(data.data));
      const id_map = data.data.reduce((a: any, b: any, c: any) => {
        a[b.id] = c;
        return a;
      }, {});
      let data_root: any = [];
      res_data.forEach((item: any) => {
        if (!item.parent_id) {
          data_root = [...(data_root || []), item];
          return;
        }
        const parent_item = res_data[id_map[item.parent_id]];
        parent_item.parent = [...(parent_item.parent || []), item];
      });
      data_root.forEach((item: any) => {
        item.parent_indeterminate = false;
        item.parent.forEach((item2: any) => {
          item2.indeterminate = false;
        });
      });
      this.privilege_list = data_root;
      console.log(data_root)
    }
    // const res: any = await getPrivilegeList();
    // this.privilege_list = initPrivilegeList();
    // if (res.status !== 200) {
    //   this.$message.error(res.message);
    //   return;
    // }
    // this.privilege_list = initPrivilegeList(res.data);
  }

  // 获取用户信息
  @changeLoading(['is_loading'])
  async getAccountPrivilege(id: number) {
    const {data} = await this.$axios.get(`${API.user_info}/${this.$route.query.id}?product_id=${this.$route.query.product_id}`)
    // const res: any = await getAccountPrivilege(id);
    data.data.forEach((item: any) => {
      this.user_info.privilege.push(item | 0)
    });
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    // this.user_info = initUserInfo(res.data);
  }
  @changeLoading(['is_loading'])
  async created() {
    this.user_id = +this.$route.query.id;
    await this.getAccountPrivilege(this.user_id);
    await this.getPrivilegeList();
    // this.privilege_list.forEach((item: any) => {
    //   item.parent_indeterminate = false;
    //   item.parent.forEach((item2: any) => {
    //     item2.indeterminate = false;
    //   });
    // });
    this.$nextTick(() => {
      this.changePrivilege()
    })
    // console.log(this.user_info);
  }
}
